import { PhotoCapture } from '../enums';
const MODULE_PREFIX = PhotoCapture.PHOTO_CAPTURE;
export const PHOTO_CAPTURE_ATTACHMENT_REQUEST = `${MODULE_PREFIX}_ATTACHMENT_REQUEST`;
export const PHOTO_CAPTURE_ATTACHMENT_SUCCESS = `${MODULE_PREFIX}_ATTACHMENT_SUCCESS`;
export const photoCaptureAttachmentDataAction = (attachments, coCode, sourceName, parentQuestionId, questionnaireQuestionId, ocrText, attachmentHistoryInfo, imageData, vehicleInfo) => ({
    type: PHOTO_CAPTURE_ATTACHMENT_REQUEST,
    payload: {
        coCode,
        attachments,
        sourceName,
        parentQuestionId,
        questionnaireQuestionId,
        ocrText,
        attachmentHistoryInfo,
        imageData,
        vehicleInfo
    }
});
export const photoCaptureAttachmentDataSuccessAction = photoCaptureAttachmentData => ({
    type: PHOTO_CAPTURE_ATTACHMENT_SUCCESS,
    payload: { photoCaptureAttachmentData }
});
//# sourceMappingURL=photoCaptureAttachmentAction.js.map